import { IonButtons, IonCard, IonCardContent, IonCardHeader, IonContent, IonHeader, IonItem, IonLabel, IonList, IonLoading, IonMenuButton, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectLog, selectMode, selectSum } from '../features/log/logSlice';
import { currentStage } from '../features/pilgrimage/current-stage';
import { ProgressMapCard } from '../components/ProgressMapCard';
import { selectRoute } from '../features/pilgrimage/pilgrimageSlice';
import { FetchStatus } from '../utils/fetch-status';
import { milesOrPoints } from '../app/miles-or-points';
import { TripTypeLabel } from './Log';

const Home: React.FC = () => {
  const sum = useSelector(selectSum),
    mode = useSelector(selectMode),
    route = useSelector(selectRoute),
    log = useSelector(selectLog),
    { index, remainder, stageReached } = currentStage(sum, (route.data || [])) || {};

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>Home</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        <IonContent class="ion-padding">
          { route.status === FetchStatus.Idle && <IonLabel color="light">Waiting...</IonLabel> }
          { route.status === FetchStatus.Pending && <IonLoading isOpen={true}></IonLoading> }
          { route.status === FetchStatus.Rejected && <IonLabel color="danger">{route.error ? `Error: ${route.error}` : `Error.`}</IonLabel> }
          { route.data !== null && (index !== undefined && index !== null && remainder !== undefined && remainder !== null && stageReached !== undefined && stageReached !== null) &&
            <ProgressMapCard index={index} remainder={remainder} stage={stageReached} />
          }
          { route.data !== null && sum > 10 && !(index !== undefined && index !== null && remainder !== undefined && remainder !== null && stageReached !== undefined && stageReached !== null) &&
            <IonCard>
              <IonCardContent>
                  <h1>Congratulations!</h1>
                  <h2>After {mode === 'miles' ? `a journey of ${sum} miles` : `earning ${sum} points`}, you’ve finally reached the end of your pilgrimage.</h2>
                  <p>Here’s a reminder of your itinerary, below:</p>
                  <IonList>
                    {log.entries.map((entry, ii) => 
                      <IonItem key={ii}>
                        <IonLabel>
                          <h3>{new Date(Date.parse(entry.date)).toLocaleDateString()}</h3>
                          <h4>
                            {Math.round(entry.distance * 10) / 10}
                            {mode === 'miles' ? 'mile' : milesOrPoints(mode, entry.distance)}
                            {mode === 'points' && ': '}
                            <TripTypeLabel type={entry.type}/> {entry.leg && <span>— {entry.leg}</span>}
                          </h4>
                          {entry.notes && <p>{entry.notes}</p>}
                        </IonLabel>
                      </IonItem>
                    )}
                  </IonList>
              </IonCardContent>
            </IonCard>
          }
        </IonContent>
      </IonContent>
    </IonPage>
  );
};

export default Home;
